import { useState } from "react";

import TaskReportContext from "../../views/task/TaskReportContext";

const TaskReportProvider = ({ children }) => {
  const [reportParams, setReportParams] = useState(null);

  return <TaskReportContext.Provider value={{ reportParams, setReportParams }}>{children}</TaskReportContext.Provider>;
};

export default TaskReportProvider;
